module.exports = __webpack_public_path__ + "media/images/emblems/Maennedorf-blazon-39cc8332466b29e7b06cfdb36baa44b7.svg";